<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'60px':defaultTop+'px',
    }">
        <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
          >
          <el-menu-item v-for="(item,index) in productsList" :index="item.src"
                        :disabled="item.disabled"
          >
              <span v-if="index!==0" v-html="item.title"></span>
              <div v-else style="cursor: pointer">
                  <span v-html="item.title" class="redSelect"></span>
                  <img :src="item.imgSrc" alt="" height="36px">
              </div>
          </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'EH-lBS生物样本库<br>数字化智能全息解决方案',
              src:'/products/qxzn',
              imgSrc:require('@/assets/tyLogo.png'),
              disabled:false
            },
            {
              title:'BioFactory<br>临床数据与样本资源库管理系统',
              src:'/products/tissueBank',
              disabled:false
            },
            {
              title:'MicrobioBank菌株库管理系统',
              src:'/products/specialBank',
              disabled:true
            },
            {
              title:'BioData数据采集系统',
              src:'/products/dataCollection',
              disabled:true
            },
            {
              title:'BioMonitor<br>生物资源运输监控管理平台',
              src:'/products/transport',
              disabled:false
            },
            {
              title:'BioCloud<br>多中心生物样本资源共享平台',
              src:'/products/share',
              disabled:false
            },
            {
              title:'BioCohort<br>自然人群队列研究管理平台',
              src:'/products/bioCohort',
              disabled:true
            },
            {
              title:'BioVision生物样本库<br>数字孪生可视化大屏展示',
              src:'/products/bioVision',
              disabled:false
            },
            // {
            //   title:'人类遗传资源管理行政审批服务',
            //   src:'/products/examine',
            //   disabled:false
            // },
            {
              title:'ISO20387技术咨询服务',
              src:'/products/iso',
              disabled:false

            },
            {
              title:'设备/耗材选型咨询服务',
              src:'/products/equipment',
              disabled:true
            },
            {
              title:'场地布局规划咨询',
              src:'/products/site',
              disabled:false
            },
            {
              title:'生物样本库其他服务',
              src:'/products/service',
              disabled:false
            },
            {
              title:'生物样本库资料下载',
              src:'/products/download',
              disabled:false
            },
        ],
        defaultActive:'/products/tissueBank',
        top:0,
        height:window.innerHeight + 120,
        defaultTop:-100
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        this.defaultActive = this.$route.path
        if (this.defaultActive === '/products/bioVision'){
            this.defaultTop = 20
            this.height = window.innerHeight + 60
        }else {
            this.defaultTop = -100
        }
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
          this.top = top
        },
        handleSelect(src){
            this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: -180px;
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 320px;
            height: 60px;
            box-sizing: border-box;
            padding: 0!important;
            line-height: 60px;
            font-size: 16px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
            text-align: left;
            &>span{
                display: flex;
                align-items: center;
                padding: 0px 0 0px 20px;
            }
            &:hover{
                background: #006efd;
                color: #fff;
                span{
                    color: #fff;
                }
            }
        }
        .el-menu-item:nth-child(2),.el-menu-item:nth-child(5),.el-menu-item:nth-child(6),.el-menu-item:nth-child(7),.el-menu-item:nth-child(8){
           span{
               line-height: 20px;
               padding: 10px 0 10px 20px;
            }
        }
        /* .el-menu-item:nth-child(1),.el-menu-item:nth-child(2),.el-menu-item:nth-child(3){*/
        /*   span{*/
        /*       line-height: 20px;*/
        /*       padding: 10px 0 10px 20px;*/
        /*    }*/
        /*}*/
        .el-menu-item:nth-child(1){
            cursor: auto;
            background: #ffe5e6!important;
            opacity: 1;
            &:hover{
                span{
                    color: #333;
                }
            }
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 25px;
                height: 100%;
                padding: 0 20px;
                span{
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
          .redSelect{
            color: red!important;
          }
            span{
                color: #fff;
            }
        }
    }
}
</style>
